<!-- begin::Scrolltop -->
<div ktScrollTop [options]="scrollTopOptions" id="kt_scrolltop" class="scrolltop">
  <span class="svg-icon" [inlineSVG]="'./assets/media/svg/icons/Navigation/Up-2.svg'"></span>
</div>
<!-- end::Scrolltop -->
